import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { ServiceIcon } from "../components/ServiceIcon";

export default function Services() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <section className="border-b border-zinc-200 bg-zinc-50">
        <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
          <span className="font-mono-label text-[11px] text-zinc-400">Our capabilities</span>
          <h1 className="mt-3 max-w-3xl font-heading text-4xl font-black tracking-tighter text-zinc-900 sm:text-5xl lg:text-6xl">
            Services & solutions, end to end
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-zinc-600">
            We cover the full technology lifecycle — design, build, secure, support and train. Explore everything we offer below.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-5 py-14 sm:px-8 lg:py-20">
        <div className="space-y-px">
          {services.map((s, i) => (
            <motion.div
              key={s.id}
              data-testid={`service-card-${s.slug}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.4 }}
              className="grid items-stretch gap-0 border border-zinc-200 lg:grid-cols-12"
            >
              <div className="relative hidden overflow-hidden lg:col-span-4 lg:block">
                <img src={s.image} alt={s.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-klein/10" />
              </div>
              <div className="p-8 lg:col-span-8 lg:p-12">
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center bg-klein text-white">
                    <ServiceIcon name={s.icon} className="h-6 w-6" />
                  </div>
                  <div>
                    <span className="font-mono-label text-[11px] text-zinc-400">0{i + 1}</span>
                    <h2 className="font-heading text-2xl font-bold tracking-tight text-zinc-900">{s.title}</h2>
                  </div>
                </div>
                <p className="mt-5 max-w-2xl text-base leading-relaxed text-zinc-600">{s.description}</p>
                <ul className="mt-6 grid gap-2.5 sm:grid-cols-2">
                  {s.features.map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm text-zinc-700">
                      <Check className="h-4 w-4 shrink-0 text-klein" /> {f}
                    </li>
                  ))}
                </ul>
                <Link to="/lets-build" className="group mt-7 inline-flex items-center gap-2 text-sm font-semibold text-klein">
                  Build with {s.title} <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}
